import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

type Props = {
  open: boolean;
  loading: boolean;
  version: number;
  onClose: () => void;
  onConfirm: () => void;
};

export default function AmendRecordConfirmDialog({
  open,
  loading,
  version,
  onClose,
  onConfirm,
}: Props) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={loading ? undefined : onClose}
    >
      <DialogTitle>Amend signed clinical record?</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Alert severity="warning">
            This action will be logged. Your name and the time you unlocked this
            record are recorded in the audit log, even if you cancel.
          </Alert>
          <Typography variant="body2">
            The signed version {version} stays intact and can always be
            retrieved. Your changes will be saved as version {version + 1}, on
            top of it.
          </Typography>
          <Typography variant="body2" component="div">
            Before anything is saved you must:
            <ul style={{ margin: '8px 0 0', paddingLeft: 20 }}>
              <li>give a reason for the amendment, and</li>
              <li>sign it off again with your own signature.</li>
            </ul>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            If you leave or cancel before signing, none of your changes are
            saved. Every change is shown on the record as &ldquo;Amended&rdquo;,
            with the old and new value, who changed it, when and why.
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="warning"
          loading={loading}
          onClick={onConfirm}
        >
          Amend Record
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
